import { render, staticRenderFns } from "./form.vue?vue&type=template&id=34a5fb7e&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=34a5fb7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5fb7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a5fb7e')) {
      api.createRecord('34a5fb7e', component.options)
    } else {
      api.reload('34a5fb7e', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=34a5fb7e&scoped=true", function () {
      api.rerender('34a5fb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/faqs/form.vue"
export default component.exports